import PageDataLoader from '../../lib/page-data/loader';
import PageKey from '../../lib/page-data/key';
import {
  NEWS_PAGE_REQUEST,
  NEWS_PAGE_FAILURE,
  NEWS_ARTICLE_REQUEST,
  NEWS_ARTICLE_RECEIVE,
  NEWS_ARTICLE_FAILURE,
  ACTIVITY_STREAM_RECEIVE,
  ACTIVITY_STREAM_REQUEST,
  PAGE_DATA_LOAD,
} from '../action-types';

export const fetchNewsPageData = (clubId, filters, request, sidebar) => async (dispatch) => {
  try {
    dispatch({ type: NEWS_PAGE_REQUEST, payload: { clubId } });
    dispatch({ type: ACTIVITY_STREAM_REQUEST, payload: { clubId } });
    const pageKey = new PageKey(clubId, 'news', filters);
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    const { messages } = pageData.data;
    dispatch({
      type: ACTIVITY_STREAM_RECEIVE,
      payload: { clubId, messages, key: pageData.key.toString() },
    });
    if (!sidebar) {
      dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    }

    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({ type: NEWS_PAGE_FAILURE, payload: { clubId, statusCode, error } });
    return { error };
  }
};

export const fetchNewsArticlePageData = (clubId, articleId, request) => async (dispatch) => {
  try {
    dispatch({ type: NEWS_ARTICLE_REQUEST, payload: { clubId, articleId } });
    const pageKey = new PageKey(clubId, 'news_article', { id: articleId });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    dispatch({ type: NEWS_ARTICLE_RECEIVE, payload: { articleId, article: pageData.data } });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({
      type: NEWS_ARTICLE_FAILURE,
      payload: { clubId, articleId, statusCode, error },
    });
    return { error };
  }
};
